import { render, staticRenderFns } from "./CardStageInfo.vue?vue&type=template&id=4ba6de34&scoped=true&"
import script from "./CardStageInfo.vue?vue&type=script&lang=js&"
export * from "./CardStageInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardStageInfo.vue?vue&type=style&index=0&id=4ba6de34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba6de34",
  null
  
)

export default component.exports